import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PlaceParserService {
  parsePlaceResult(placeResult: any): {
    city: string;
    state: string;
    country: string;
    zipcode: string;
  } {
    let city = '';
    let state = '';
    let country = '';
    let zipcode = '';

    // Check if address_components is available
    if (placeResult.address_components) {
      placeResult.address_components.forEach((component: any) => {
        if (
          component.types.includes('locality') ||
          component.types.includes('administrative_area_level_3')
        ) {
          city = component.long_name; // Extract city
        }
        if (component.types.includes('administrative_area_level_1')) {
          state = component.long_name; // Extract state or province
        }
        if (component.types.includes('country')) {
          country = component.long_name; // Extract country
        }
        if (component.types.includes('postal_code')) {
          zipcode = component.long_name; // Extract country
        }
      });
    }

    return { city, state, country, zipcode };
  }
}
